{
  "user": {
    "dashboard": {
      "placeholder": "Hi this is the dashboard"
    }
  },
  "manager": {
    "dashboardIndex": {
      "welcomeBack": "Welcome back, {name}",
      "subtitle": "Here's what's happening with your community today",
      "todaysDate": "Today's date is {date}",
      "statActiveMembers": "Active Members",
      "vsLastMonth": "vs last month",
      "statNewThisWeek": "New This Week",
      "vsLastWeek": "vs last week",
      "statRevenueToday": "Revenue Today",
      "vsYesterday": "vs yesterday",
      "statProgramsActive": "Programs Active",
      "locked": "Locked",
      "statTotalRevenue": "Total Revenue",
      "thisMonth": "this month",
      "headTitle": "Manager Dashboard",
      "chartTypeRevenue": "Revenue",
      "chartTypeActiveMembers": "Active Members",
      "chartTypeNewMembers": "New Members",
      "chartTypeProgramSignups": "Program signups",
      "chartTitle": "{type} trends over the past 7 days",
      "chartValueFallback": "Value",
      "chartTooltip": "{type}: {value}",
      "quickActionAddUser": "Add a new user",
      "quickActionSendNotification": "Send notification",
      "quickActionCreateInvoice": "Create invoice",
      "emptyRevenueTitle": "No revenue data yet",
      "emptyRevenueDescription": "Start accepting payments to see revenue trends here.",
      "emptyActiveMembersTitle": "Active members data not available",
      "emptyActiveMembersDescription": "Create a membership and start accepting payments to see active members here.",
      "emptyNewMembersTitle": "New members data not available",
      "emptyNewMembersDescription": "Create a membership and start accepting payments to see new members here.",
      "emptyProgramSignupsTitle": "Program signups data not available",
      "emptyProgramSignupsDescription": "Create a program and start accepting signups.",
      "emptyDefaultTitle": "No data available",
      "emptyDefaultDescription": "Unable to display chart data at this time."
    }
  }
}
